import React, { Component } from 'react'
import axios from 'axios'

import moment from 'moment'
import spreadsheetValidation from './spreadsheetValidations'

export class DashBoardModal extends Component {
  state = {
    departmentLists: [],
    selectedDepartment: '',
    department: ['']
  }

  render () {
    let invalid = this.props.grid

    const invalidData = invalid.filter(crf => {
      return (
        spreadsheetValidation.numbers(crf[7].value, crf[8].value) ||
        spreadsheetValidation.dates(crf[8].value, crf[7].value)
      )
    })
    const gridWithInput = this.props.grid.filter(
      crf =>
        crf[7].value.trim() !== '' &&
        crf[7].value.trim() !== 'APV#' &&
        crf[8].value !== '' &&
        crf[8].value !== 'Posting Date'
    )

    console.log('invalids', invalid)
    return (
      <div id='modalBody' className='modalBody'>
        <div className='modalContainer'>
          <div className='modalbg'>
            <div id='modalContentDashboard'>
              <div className='updatingChecksContainer'>
                {gridWithInput.length === 0 && invalidData.length === 0 ? (
                  <>
                    <h4 className='returnHeader'>Nothing To Update</h4>
                  </>
                ) : (
                  <>
                    {invalidData.length === 0 && gridWithInput.length !== 0 ? (
                      <>
                        <h4>Update to Check Preparation</h4>
                        <h5 className='returnHeader'>
                          Please make sure that you already downloaded the csv
                          file or else CRF will not be updated.
                        </h5>
                      </>
                    ) : (
                      <h4>Error</h4>
                    )}
                  </>
                )}

                {invalidData.map(crf => {
                  return (
                    <div className='updatingChecksContent'>
                      <div className='inProcessCrfDetail'>
                        <span>CRF#:{crf[3].value}</span>
                      </div>
                      <div className='inProcessCrfDetail'>
                        <span
                          style={
                            spreadsheetValidation.numbers(crf[7].value)
                              ? textRed
                              : null
                          }
                        >
                          APV#:
                          {spreadsheetValidation.numbers(crf[7].value)
                            ? crf[7].value.trim() === ''
                              ? 'Empty'
                              : 'invalid'
                            : crf[7].value.trim()}
                        </span>
                      </div>
                      <div className='inProcessCrfDetail'>
                        <span
                          style={
                            spreadsheetValidation.dates(crf[8].value)
                              ? textRed
                              : null
                          }
                        >
                          Posting Date:
                          {crf[8].value === ''
                            ? 'Empty'
                            : spreadsheetValidation.dates(crf[8].value)
                            ? 'Invalid'
                            : crf[8].value}
                        </span>
                      </div>
                    </div>
                  )
                })}
              </div>
              {gridWithInput.length === 0 && invalidData.length === 0 ? null : (
                <>
                  {invalidData.length === 0 &&
                  gridWithInput.length !== 0 ? null : (
                    <div className='returnHeader'>
                      <h6>Apv number must be 9 numerical characters.</h6>
                      <h6>Date must be valid and in mm/dd/yyyy format</h6>
                    </div>
                  )}
                </>
              )}

              <div className='updateToCheckPrepareButtonContainer'>
                {gridWithInput.length === 0 && invalidData.length === 0 ? (
                  <>
                    <button
                      className='updateToCheckPrepareCloseButton'
                      onClick={this.props.closeModal}
                    >
                      Ok
                    </button>
                  </>
                ) : (
                  <>
                    {invalidData.length === 0 && gridWithInput.length !== 0 ? (
                      <>
                        <button
                          className='updateToCheckPrepareCloseButton'
                          onClick={this.props.closeModal}
                        >
                          Cancel
                        </button>
                        <button
                          className='updateToCheckPrepareUpdateButton'
                          onClick={this.props.handleUpdateToCheckPreparation}
                        >
                          Confirm
                        </button>
                      </>
                    ) : (
                      <button
                        className='updateToCheckPrepareCloseButton'
                        onClick={this.props.closeModal}
                      >
                        Close
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const textRed = {
  color: 'red'
}

export default DashBoardModal
